<template>
  <span class="lean-list-itme-content-part">
    <span v-if="getTitle.split('#,#').length === 1">
      <span :class="classParms">
        {{ getTitle }}
      </span>
    </span>
    <span v-else>
      <ul>
        <li v-for="(sub, index) in getTitle.split('#,#')" :key="index">
          <span :class="classParms">
            {{ sub }}
          </span>
        </li>
      </ul>
    </span>
  </span>
</template>

<script>
export default {
  name: 'LeanListItemContentPart',
  props: {
    title: {
      type: Object | String,
      required: true
    },
    classParms: {
      type: String,
      default: 'v-list-item__title'
    }
  },
  computed: {
    getTitle() {
      if (Array.isArray(this.title)) {
        return this.title.join(', ');
      }
      return this.title;
    }
  }
};
</script>
